export default "__VITE_ASSET__CCGcEakV__"